/** Used as a react router parent with Outlet component child.
 *  Does not take any props, but can push global props,
 *    ie, html title, to Outlet.
 */
import React from "react"
import { useLocation, Outlet } from "react-router-dom"
import { Helmet } from "react-helmet-async"
import Sidebar from "../../../components/Sidebar/Sidebar"
import Topbar from "../../../components/Topbar/Topbar"

import "./MainGlobalLayout.scss"

// constants
import navData from "constants/pageData"

const MainGlobalLayout = () => {
  const { pathname } = useLocation()
  const [htmlTitle, setHtmlTitle] = React.useState()

  // set page title from page data
  React.useEffect(() => {
    const getPageItem = () => {
      let foundItem = null
      navData.forEach((item) => {
        if (item.url === pathname) foundItem = item
        item.items?.forEach((subItem) => {
          if (subItem.url === pathname) foundItem = subItem
        })
      })
      return foundItem
    }

    const pageItem = getPageItem()
    setHtmlTitle(pageItem?.htmlTitle || pageItem?.title || pageItem?.name)
  }, [pathname])

  // this page-specific classname can allow for targeting page layouts, eg, where the user can scroll the entire page or only contents within the page
  const layoutClassName = React.useMemo(() => {
    if (pathname.startsWith("/my-prime")) return `main-layout-${pathname.replace("/", "")}`
    if (pathname.startsWith("/study/")) {
      if (pathname.includes("/activity/")) {
        return `main-layout-activity`
      }
      if (pathname.includes("/assessment/")) {
        return `main-layout-assessment`
      }
      const pathnameParts = pathname.split("/")
      let tabName = pathnameParts[pathnameParts.length - 1]
      if (pathname.includes("/study-data/")) tabName = "data"
      if (pathname.includes("/locations/")) tabName = "locations"
      return `main-layout-study main-layout-study-${tabName}`
    }
    return null
  }, [pathname])

  return (
    <>
      <Helmet>
        {/* htmlTitle is not updating when navigating through routes. Passing HTML title to child thru route context. */}
        <title>{htmlTitle}</title>
      </Helmet>
      <div className={`main-global-layout${layoutClassName ? ` ${layoutClassName}` : ""}`}>
        <div className="left-section">
          <Sidebar />
        </div>
        <div className={`right-section ${pathname.startsWith("/my-prime") && "right-section-my-prime"}`}>
          <div className={`top-section ${pathname === "/my-prime" && "my-prime-topbar"}`}>
            <Topbar />
          </div>
          <Outlet context={{ htmlTitle }} />
        </div>
      </div>
    </>
  )
}

export default MainGlobalLayout
